import { Injectable } from '@angular/core';
import { getAuth, signInWithPopup, GoogleAuthProvider, AuthProvider } from 'firebase/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  GoogleAuth() {
    return this.AuthLogin(new GoogleAuthProvider());
  }

  // Auth logic to run auth providers
  AuthLogin(provider: AuthProvider) {
    try {
      const auth = getAuth();
      return signInWithPopup(auth, provider);
    } catch (e) {
      return Promise.reject(e);
    }
  }

}

